import ContactsMixin from "../../mixins/contacts-mixin";
import ContactFormListsMixin from "../../mixins/contact-form-lists-mixin";
import ExportFileMixin from "../../mixins/export-file";

Vue.component("contacts", {

    mixins: [ContactsMixin, ContactFormListsMixin, require("../../mixins/vuetable-css-mixin"), ExportFileMixin],

    data () {
        return {
            searchParams: {
                filter_text: "",
                archived_filter: false,
            },
            showBulkActions: false,
            currentContact: {},
            contactsToMerge: [],
            showBulkMergeModal: false,
            columns: [
                {
                    name: "__checkbox",
                    titleClass: "center aligned",
                    dataClass: "center aligned column-checkbox"
                },
                {
                    name: "__slot:contact_name",
                    sortField: "contact_name",
                    title: "Full Name",
                    dataClass: "text-nowrap column-width-250 column-width-250-fixed"
                },
                {
                    name: "email",
                    dataClass: "text-nowrap"
                },
                {
                    name: "mobile",
                    dataClass: "text-nowrap"
                },
                {
                    name: "assets_count",
                    title: "Assets",
                    titleClass: "text-center",
                    dataClass: "text-nowrap text-center font-medium"
                },
                {
                    name: "tickets_count",
                    title: "Tickets",
                    titleClass: "text-center",
                    dataClass: "text-nowrap text-center font-medium"
                },
                {
                    name: "inspections_count",
                    title: "Inspections",
                    titleClass: "text-center",
                    dataClass: "text-nowrap text-center font-medium"
                },
                {
                    name: "__slot:actions",
                    title: "",
                    titleClass: "center aligned",
                    dataClass: "text-right"
                }
            ]
        };
    },

    watch: {
        editModalTitle: function (newVal, oldVal) {
            this.editModalTitle = newVal;
        }
    },

    created () {
        let self = this;
        Bus.$on("contact-created", function () {
            self.hideContactCreateForm();
            Vue.nextTick(() => self.$refs.vuetable.refresh());
        });

        Bus.$on("contact-updated", function (data) {
            Vue.nextTick(() => self.$refs.vuetable.refresh());
        });

        Bus.$on("contact-deleted", function () {
            Vue.nextTick(() => self.$refs.vuetable.refresh());
        });
    },

    methods: {
        checkboxToggled () {
            this.contactsToMerge = this.selectedContacts();
            this.showBulkActions = this.$refs.vuetable.selectedTo.length > 0;
        },

        selectedContacts () {
            return this.$refs.vuetable ? this.$refs.vuetable.selectedTo : [];
        },

        doFilter () {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        reloadTable () {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
            this.$refs.vuetable.selectedTo = [];
        },

        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },

        onChangePage (page) {
            this.$refs.vuetable.changePage(page);
        },

        toggleArchivedContacts () {
            this.$set(this.searchParams, "archived_filter", !this.searchParams.archived_filter);
            this.doFilter();
        },

        onActionClick (action, data, index) {
            switch (action) {
                case "editContact":
                    this.currentContact = data;
                    this.$refs.editContact.toggleContactForm();
                    break;
            }
        },

        showMergeModal () {
            this.contactsToMerge = this.selectedContacts();
            $("#merge-contacts-modal").modal("show");
        },

        hideMergeModal () {
            this.contactsToMerge = this.selectedContacts();
            $("#merge-contacts-modal").modal("hide");
        },

        toggleBulkMergeModal () {
            this.showBulkMergeModal = !this.showBulkMergeModal;
        },

        bulkMergeExternalContacts () {
            App.patch("/contacts/merge-external", new AppForm({}))
            .then((response) => {
                this.toggleBulkMergeModal();
                this.reloadTable();
                toastr.success(response);
            }).catch(error => {
                toastr.error(error.message);
            });
        },

        exportContacts(){
            this.$set(this.searchParams, "sort", this.$refs.vuetable?.getSortParam());
            this.exportData("/contacts/export", this.searchParams, this.$dayjs().format("DD-MM-YYYY") + " Contacts Export.xlsx");
        }
    },
});
